export const LAND_REPORT_QUERY_KEY = {
  LAND_REPORT: 'land_report',
  FIELD_HISTORY: 'land_report.field_history',
}
